import React from 'react';
import { createMuiTheme } from '@material-ui/core';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';

const theme = createMuiTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ['Manrope'].join(','),
    },

    breakpoints: {
      values: {
        sm: 600, // Small screen / phone
        md: 920, // Medium screen / tablet
        lg: 1200, // Large screen / desktop
        xl: 1500,
        xs: 0,
        // xxl: 1800,
      },
    },

    palette: {
      contrastThreshold: 3,
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#293B85',
        contrastText: '#fff',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        //main: '#0abb87',
        main: '#F5F6F9',
        // dark: will be calculated from palette.primary.main,
        contrastText: '#ffffff',
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: '#DC1F1F',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      success: {
        // light: will be calculated from palette.primary.main,
        main: '#293B85',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
    },
    overrides: {
      // PrivateNotchedOutline: {
      //   legendNotched: {
      //     maxWidth: '0px',
      //   }
      // },
      MuiDialog: {
        paper: {
          borderRadius: 32,
          padding: '10px',
        },
      },
      MuiDialogTitle: {
        root: {
          fontSize: '24px !important', // Font o'lchamini o'zgartirish
          fontWeight: 800,  // Yozuvning qalinligini o'zgartirish
          color: '#000', // Rangni o'zgartirish
          padding: '12px 24px', // Yashirishning o'lchamini o'zgartirish
        },
      },
      MuiTooltip: {
        tooltip: {
          fontSize: '12px',
        },
      },
      MuiButton: {
        root: {
          borderRadius: '20px',
          fontSize: '20px',
          height: '53px',
        },
      },
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */

    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        // raisedPrimary: { color: '#fff' },
        disableRipple: true, // No more ripple, on the whole application 💣!
      },

      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 1,
      },
    },
  }
);

export default function ThemeProvider(props: { children: React.ReactNode }) {
  const { children } = props;

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
